

import React, { useEffect, useRef, useState } from 'react';
import { Check } from "feather-icons-react/build/IconComponents";
import "../../../style/css/sales-invoice-terminal.css";
import {
  useTerminalChrome,
  TermCmdBar,
  TermColumns,
  TermStatusBar,
} from "../terminal/TerminalChrome";
import { useSelector } from 'react-redux';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { AddProductBOQ, getProductBOQIngredients, getProductBoqListView } from '../../../services/MasterApiServices';
import toast from 'react-hot-toast';
import dayjs from "dayjs";
import { DatePicker } from "antd";
import { InvProduction } from '../../../core/json/invProduction';
import { InvProductionDetail } from '../../../core/json/invProductionDetail';
import { saveproduction } from '../../../services/StockApiServices';

const AddProduction = ({ mode, updateData, productionData, ProductBOQData, handleClose, onsuccess }) => {
  const [ingredients, setIngredients] = useState([])
  const { unitList, productList } = useSelector((state) => state.usersetting);
  const { branch } = useSelector((state) => state.branchlist);
  const { userId } = useSelector((state) => state.userauth);
  console.log(updateData);
  
  const { register,
    setValue,
    getValues,
    handleSubmit,
    watch,
    control,
    reset,
    formState: { errors }, } = useForm();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'row',
  });
 
  const closeButtonRef = useRef();

  const closemodal = () => {
    if (closeButtonRef.current) {
      closeButtonRef.current.click();
    }
  };

  const handlesave = async (formData) => {
    console.log(formData);// Handle form submission
    const objproduct = new InvProduction()
    objproduct.Date = dayjs(formData.date).format("YYYY-MM-DD");
    objproduct.Cost = ProductBOQData?.find(e => e.guid == formData.product)?.cost;
    objproduct.Branch = branch;
    objproduct.Quanitity = Number(formData?.quantity);
    objproduct.Entryno = formData?.entrynumber;
    objproduct.Unit = unitList?.find(e => e.guid == formData.unit);
    objproduct.Product = ProductBOQData?.find(e => e.guid == formData.product);
    objproduct.updatedUser = `{${userId?.id}}`;
    objproduct.createdUser = `{${userId?.id}}`;
    objproduct.id = mode == 'Edit' ? updateData?.id : 0;
    objproduct.guid = mode == 'Edit' ? updateData?.guid : '';

    for (const row of formData.row) {
      const objproductdetail = new InvProductionDetail()

      objproductdetail.Product = productList?.find(e => e.guid == row.product);
      objproductdetail.ProductQty = Number(row.totalquantity);
      objproductdetail.Unit = unitList?.find(e => e.guid == row.unit);
      objproductdetail.Cost = Number(row.cost);
      objproductdetail.id = Number(row.id);
      objproductdetail.guid = row.guid;
      objproductdetail.updatedUser = `{${userId?.id}}`;
      objproductdetail.createdUser = `{${userId?.id}}`;
      objproduct.invProductionDetails.push(objproductdetail);
    }

    try {
      const response = await saveproduction(objproduct);
      if (response == true) {
        onsuccess()
        if(mode=='Add'){
          toast.success("success")
          handlenew(formData?.entrynumber)
          reset()
        }
        else{
          handleClose()
          toast.success("Updated successfuly")
        }
      }
      else {
        toast.success(response.data)
      }

    } catch (error) {
      toast.error(error?.response?.data?.Message);
      console.error("Error handling category:", error?.response?.data?.Message);
    }
  }
const handlenew=(num)=>{
  
  let counter = parseInt(num.replace(/\D/g, "")) + 1;
      setValue(`entrynumber`, `WP${counter}`);
  setValue(`product`, '')
      setValue('unit', '')
      setValue('quantity', '');
      remove()
}
  useEffect(() => {
    if (mode == 'Add') {

      handleEntryNo();
    }
    else {
      handleEdit()
      setValue(`product`, updateData?.product.guid)
      handleinvProductBoqList(updateData?.product.guid)
      const unitdata = ProductBOQData?.find(e => e.guid == updateData?.product.guid)
      setValue('unit', unitdata?.unit?.guid)
      setValue('quantity', updateData?.quanitity);
      setValue('date', updateData?.date);
    
    }
    handleIngredients();
  }, [mode, updateData]);
  const handleEdit = () => {
    setValue(`entrynumber`, updateData.entryno);
  }

  const handleIngredients = async () => {
    try {
      const response = await getProductBOQIngredients(branch);
      if (Array.isArray(response)) {
        setIngredients(response);
      } else {
        setIngredients([]); // If response is not an array, reset to an empty array
      }
    } catch (error) {
      console.log(error?.response?.data?.Message || "something went wrong");
      setIngredients([]);
    }
  };

  const handleproduct = (val) => {
    setValue(`product`, val.target.value)
    const data = ProductBOQData?.find(e => e.guid == val.target.value)
    setValue('unit', data?.unit?.guid)
    handleinvProductBoqList(val.target.value)
    console.log(updateData?.product.guid, val.target.value);
    
    if(mode == 'Edit'&& updateData?.product.guid == val.target.value){

      setValue('quantity', updateData?.quanitity);
    }
    else{
      setValue('quantity', '');

    }


  }
  const handleinvProductBoqList = async (id) => {
    try {
      const response = await getProductBoqListView(branch);
      if (Array.isArray(response)) {
        const boq = response?.find((e) => e.product.guid == id)

        if (boq?.productBOQDetails?.length > 0) {
          // Map the productBOQDetails if available
          const boqdata = boq?.productBOQDetails?.map((e, i) => ({
            id: e.id,
            product: e.product.guid,
            unit: e.unit.guid,
            quantity: (e.quantity / boq.totalqty || 1)?.toFixed(2),
            wastage: e.wastagePercentage,
            Cfactor: e.conversionFactor,
            RndTo: false, // Assuming this flag is set to false by default
            cost: e.cost,
            tcost: (e.quantity * e.conversionFactor * e.cost) +
              ((e.quantity * e.conversionFactor * e.cost * e.wastagePercentage) / 100),
            totalquantity: mode == 'Edit' ? updateData?.invProductionDetails[i]?.productQty : 0
          }));

          append(boqdata);
          setValue('row', boqdata)
        } else {
          remove()
        }

      }
    } catch (error) {
      console.log(error?.response?.data?.Message);

    }
  };

  const handleEntryNo = async () => {
    try {
      const maxEntryNumber =
        productionData?.length > 0
          ? productionData
            .map((data) => parseInt(data.entryno.replace(/\D/g, ""))) // Extract and parse numbers
            .reduce((max, num) => Math.max(max, num), 0) // Find the maximum number
          : 0;
   
      let counter = maxEntryNumber + 1;
      setValue(`entrynumber`, `WP${counter}`);
      counter++;
    } catch (error) {
      console.error("Failed to fetch purchase invoices", error);
    }
  };

  const handlequantity = (val) => {
    setValue('quantity', val);
    fields?.map((field, i) => {

      const fieldQuantity = Number(field.quantity) || 1; // Ensure quantity exists in the field
      const q = val * fieldQuantity

      setValue(`row[${i}].totalquantity`, Number(q)?.toFixed(2));
    });
  };


  // view preferences only - theme, full screen, More row, visible columns
  const chrome = useTerminalChrome("production");
  const selectedProduct = ProductBOQData?.find(
    (p) => p.guid == watch("product")
  );
  const unitName = unitList?.find((u) => u.guid == watch("unit"))?.name;
  // quantities carry 2 decimals - round away float noise in the sum
  const qtyTotal =
    Math.round(
      (fields || []).reduce(
        (sum, f, i) => sum + (Number(watch(`row[${i}].totalquantity`)) || 0),
        0
      ) * 100
    ) / 100;

  return (
    <div>
      <div
        className="modal fade show si-term si-term--txn"
        data-si-theme={chrome.theme}
        style={{ display: "block" }}
      >
        <div className="modal-dialog si-dialog">
          <div className="modal-content si-content">
            <form className="si-form" onSubmit={handleSubmit(handlesave)}>
              <div className="si-grid">
                <div className="si-left">
                  {/* ============ COMMAND BAR ============ */}
                  <TermCmdBar
                    chrome={chrome}
                    title="Production"
                    docNo={watch("entrynumber")}
                    state={
                      mode == 'Edit'
                        ? { key: "edit", label: "Editing" }
                        : mode == 'View'
                        ? { key: "edit", label: "Viewing" }
                        : { key: "new", label: "New" }
                    }
                    onBack={handleClose}
                  />
                  {/* entry number - the header shows it */}
                  <input
                    type="text"
                    id="entrynumber"
                    className="si-offscreen"
                    tabIndex={-1}
                    aria-hidden="true"
                    disabled
                    {...register("entrynumber")}
                  />

                  {/* ============ HEADER FIELDS ============ */}
                  <section className="si-strip">
                    <div className="si-strip-row si-strip-row--auto">
                      <div
                        className={
                          mode == 'View' ? "si-fld si-fld--ro" : "si-fld"
                        }
                      >
                        <label>
                          Date <span className="si-req">*</span>
                        </label>
                        <Controller

                          control={control}
                          name={`date`}
                          render={({
                            field: { onChange, value },
                          }) => (
                            <DatePicker
                            disabled={mode=='View'}
                              className="si-date"
                              placeholder={
                                value ? dayjs(value) : dayjs()
                              }
                              value={value ? dayjs(value) : dayjs()}
                              maxDate={dayjs()}
                              format="DD-MM-YYYY"
                              onChange={(date) => onChange(date)}
                            />
                          )}
                        />
                      </div>
                      <div
                        className={
                          mode == 'View'
                            ? "si-fld si-fld--wide si-fld--ro"
                            : "si-fld si-fld--wide"
                        }
                      >
                        <label>
                          Product <span className="si-req">*</span>
                        </label>

                        <select
                          {...register('product', { required: true })}
                          className="si-in"
                          disabled={mode=='View'}
                          onChange={(val) => {
                            // ensure the field value is updated
                            handleproduct(val); // handle custom logic
                          }}
                        >
                          <option value="">Select product</option>
                          {ProductBOQData?.map((product) => (
                            <option key={product.guid} value={product.guid}>
                              {product.name}
                            </option>
                          ))}
                        </select>

                        {/* Display error message for required validation */}
                        {errors?.product?.type === "required" && (
                          <span className="si-err">Product is required</span>
                        )}

                      </div>
                      <div
                        className={
                          mode == 'View' ? "si-fld si-fld--ro" : "si-fld"
                        }
                      >
                        <label>
                          Quantity <span className="si-req">*</span>
                        </label>
                        <input
                          type="text"
                          id="quantity"
                          className="si-in"
                          disabled={mode=='View'}
                          {...register("quantity", { required: "Quantity is required" })}
                          onChange={(e) => handlequantity(e.target.value)}
                        />
                        {errors.quantity && <span className="si-err">{errors.quantity.message}</span>}
                      </div>

                      <div className="si-fld si-fld--ro">
                        <label>
                          Unit <span className="si-req">*</span>
                        </label>
                        <Controller

                          control={control}
                          name={`unit`}
                          render={({ field }) => (
                            <select {...field} className="si-in" disabled >
                              <option value="">Select unit</option>
                              {unitList && unitList?.map((unit) => (
                                <option key={unit.guid} value={unit.guid}>
                                  {unit.name}
                                </option>
                              ))}
                            </select>
                          )}
                        />
                      </div>
                    </div>
                  </section>

                  {/* ============ LINES ============ */}
                  <section className="si-lines">
                    <TermColumns chrome={chrome} columns={[]} />

                    <div className="si-tablewrap">
                      <table
                        className="si-table"
                        style={{ minWidth: "912px" }}
                      >
                        <thead>
                          <tr>
                            <th style={{ width: "240px" }}>Product</th>
                            <th style={{ width: "96px" }}>Unit</th>

                            <th className="n" style={{ width: "96px" }}>
                              Base Quantity
                            </th>
                            <th className="n" style={{ width: "96px" }}>
                              Wastage %
                            </th>
                            <th className="n" style={{ width: "96px" }}>
                              C.factor
                            </th>

                            <th className="n" style={{ width: "96px" }}>
                              Cost
                            </th>
                            <th className="n" style={{ width: "96px" }}>
                              T.cost
                            </th>
                            <th className="n" style={{ width: "96px" }}>
                              Quantity
                            </th>

                          </tr>
                        </thead>
                        <tbody>
                          {fields?.map((row, index) => (
                            <tr className="si-line" key={row.id}>
                              <td>

                                <Controller

                                  control={control}
                                  name={`row[${index}].product`}
                                  rules={{
                                    required: true,
                                    validate: (value) => {
                                      const selectedProducts = watch("row")?.map((row) => row.product); // Get all selected products
                                      const isDuplicate = selectedProducts.filter((prod) => prod === value)?.length > 1;
                                      return !isDuplicate || "Duplicate product selected!";
                                    },
                                  }}
                                  render={({ field }) => (
                                    <>
                                      <select
                                        {...field}
                                        className="si-cellin si-cellin--text si-cellin--ro"

                                        disabled
                                      >
                                        <option value="">Select product</option>
                                        {ingredients?.map((product) => (
                                          <option key={product.guid} value={product.guid}>
                                            {product.name}
                                          </option>
                                        ))}

                                      </select>

                                      {errors?.row?.[index]?.product?.message && (
                                        <span className="si-err">{errors.row[index].product.message}</span>
                                      )}
                                    </>
                                  )}
                                />


                              </td>
                              <td>
                                <Controller
                                  control={control}

                                  name={`row[${index}].unit`}
                                  render={({ field }) => (
                                    <select {...field} className="si-cellin si-cellin--text si-cellin--ro" disabled >
                                      <option value="">Select unit</option>
                                      {unitList && unitList?.map((unit) => (
                                        <option key={unit.guid} value={unit.guid}>
                                          {unit.name}
                                        </option>
                                      ))}
                                    </select>
                                  )}
                                />
                              </td>

                              <td className="n">
                                <input
                                  type="number"
                                  min={0}
                                  step="any"
                                  maxLength={7}
                                  className="si-cellin si-cellin--ro"
                                  tabIndex={-1}
                                  value={watch(`row[${index}].quantity`) || ''}  // Bind the value with watch
                                  disabled
                                />
                              </td>
                              <td className="n">

                                <input
                                  type="number"
                                  step="any"
                                  min={0}
                                  max={100}
                                  maxLength={3}
                                  className="si-cellin si-cellin--ro"
                                  tabIndex={-1}
                                  value={watch(`row[${index}].wastage`)}  // Bind the value with watch
                                  disabled
                                />
                              </td>
                              <td className="n">

                                <input
                                  type="number"
                                  min={0}
                                  step="any"
                                  className="si-cellin si-cellin--ro"
                                  tabIndex={-1}
                                  maxLength={7}

                                  value={watch(`row[${index}].Cfactor`) || ''}  // Bind the value with watch
                                  disabled
                                />
                              </td>

                              <td className="n">
                                <input
                                  type="number"
                                  step="any"
                                  min={0}
                                  className="si-cellin si-cellin--ro"
                                  tabIndex={-1}
                                  {...register(`row[${index}].cost`)}
                                  disabled
                                />
                              </td>
                              <td className="n">
                                <input
                                  type="number"
                                  step="any"
                                  min={0}
                                  className="si-cellin si-cellin--ro"
                                  tabIndex={-1}
                                  {...register(`row[${index}].tcost`)}
                                  disabled
                                />
                              </td>
                              <td className="n">
                                <input
                                  type="number"
                                  step="any"
                                  min={0}
                                  className="si-cellin si-cellin--ro"
                                  tabIndex={-1}
                                  {...register(`row[${index}].totalquantity`)}
                                  disabled
                                />
                              </td>

                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {fields?.length === 0 && (
                        <div className="si-empty">
                          <p className="big">No lines yet</p>
                          <p>Pick a product to load its lines.</p>
                        </div>
                      )}
                    </div>

                    <div className="si-lines-foot">
                      <span>
                        Lines <b>{fields?.length}</b>
                      </span>
                      <span>
                        Qty <b>{qtyTotal}</b>
                      </span>
                    </div>
                  </section>
                  {/* <div className="col-lg-2 float-right">
                    {watch()?.row && (
                      <>

                        {(() => {
                          let totalSum = watch().row.reduce((acc, e) => acc + (e.tcost || 0), 0);
                          return (
                            <div className='col-12'>

                              <p>Total cost: <b>{totalSum}</b> </p>
                            </div>
                          );
                        })()}
                      </>
                    )}
                  </div> */}

                  {/* ============ STATUS BAR ============ */}
                  <TermStatusBar
                    context={[branch?.name, selectedProduct?.name]}
                  />
                </div>

                {/* ============ RAIL ============ */}
                <aside className="si-rail">
                  <div className="si-rail-scroll">
                    <div className="si-card">
                      <div className="si-card-h">Product</div>
                      <div className="si-party">
                        <div className="nm">
                          {selectedProduct?.name || "No product selected"}
                        </div>
                        <div className="meta">
                          {selectedProduct
                            ? unitName || ""
                            : "Pick a product to start"}
                        </div>
                      </div>
                    </div>

                    <div className="si-card">
                      <div className="si-card-h">Summary</div>
                      <div className="si-tot">
                        <div className="si-tr">
                          <span className="l">Lines</span>
                          <span className="v">{fields?.length}</span>
                        </div>
                        <div className="si-tr">
                          <span className="l">Qty</span>
                          <span className="v">{qtyTotal}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="si-actions">
                    {mode !=='View' &&
                      <button type="submit" className="si-btn si-btn--primary">
                        <Check />
                        <span>Save</span>
                      </button>
                    }
                  </div>
                </aside>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddProduction;
